import http from '../../utils/fetch';
export default {
    baseurl:'/api/swyl/v1/basic/bscResource',

    userAllResList(q){
        return http({
            url: this.baseurl+'/userAllResList',
            method: 'post',
            params: q
        });
    },
    getAllResCheckedByRoleId(roleid){
        return http({
            url: this.baseurl+'/getAllResCheckedByRoleId',
            method: 'post',
            params: {roleid}
        });
    },
    getAllResCheckedByUsercode(usercode){
        return http({
            url: this.baseurl+'/getAllResCheckedByUsercode',
            method: 'post',
            params: {usercode}
        });
    },
    resList(q){
        return http({
            url: this.baseurl+'/resList',
            method: 'post',
            params: q
        });
    },
    updateById(q){
        return http({
            url: this.baseurl+'/updateById',
            method: 'post',
            params: q
        });
    },
    insert(q){
        return http({
            url: this.baseurl+'/insert',
            method: 'post',
            params: q
        });
    },
    deleteById(id){
        return http({
            url: this.baseurl+'/deleteById',
            method: 'post',
            params: {id}
        });
    },

}
